<mat-progress-bar mode="determinate" [value]="progressValue" [matTooltip]="tooltipText ? getTooltipTranslation() : ''" matTooltipClass="label-tooltip"></mat-progress-bar>

